<div class="job-posts placements agreements padding-left-15px padding-top-15px padding-right-15px">
  <div class="card border-radius-top-right my-profile-form skillassest-form">
    <div class="card-body bk-color-sky border-radius-top-right padding-top padding-left-0px padding-right-0px margin-left-0px padding-bottom-0px">
      <div class="row margin-left-0px margin-right-0px">
        <!--<label *ngIf="isGraphLoading">Please wait, refreshing...</label>-->
        <div class="col-md-12 padding-left-0px padding-right-0px ">
          <h4 class="margin-left-10px font-weight-bold margin-bottom-10px margin-top-10">{{ReportType}} <a (click)="TableView()" class="nav-link-hand" title="Tabular view"><i class="fas fa-table"></i></a></h4>
          <div class="text-align-center">
            <button type="button"
                    *ngIf="!bInit"
                    class="btn actions-btn-prime font-size-13px margin-left-14pe margin-top-3pe" (click)="LoadOrRefresh()">
              Click To Load
            </button>
            <!--<a (click)="LoadOrRefresh()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here Load Graph" *ngIf="!bInit">Click To Load</a>-->
          </div>
        </div>
        <div class="col-md-12 padding-left-0px padding-right-0px ">
          <label *ngIf="isRequesting">Please wait, refreshing...</label>
          <p-chart type="line" [data]="graph" [options]="options" *ngIf="graph && !isRequesting"></p-chart>
          <!--<plotly-plot [data]="graph.data" [layout]="graph.layout" *ngIf="graph && !isRequesting"></plotly-plot>-->



          <canvas *ngIf="!isRequesting" id="barChart_{{ReportType}}" class="height-210px width-100pe" hidden></canvas>
          <!--<label *ngIf="isRequesting">Please wait, refreshing...</label>-->
        </div>
        <div class="row col-md-12 bk-color-sky padding-left-0px padding-right-0px margin-left-0px margin-right-0px">
          <div class="col-md-12 padding-left-0px padding-right-0px">
            <div class="accordion" [id]="'accordionExample'+ReportType" hidden>
              <div class="card margin-bottom-5px card-background-transparent">
                <div class="card-header font-weight-normal wh-header border-all-0px  label-table-color border-top-0px border-right-0  padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" [id]="'heading'+ReportType">
                  <div class="row">
                    <div class="col-md-12 text-align-center">

                      <button class="btn font-size-29px padding-top-0px line-height-new background-norepeat padding-right-0px padding-left-0px" type="button" data-toggle="collapse" attr.data-target="#collapse{{ReportType}}" aria-expanded="true" [attr.aria-controls]="'collapse'+ReportType">
                        ..
                      </button>

                    </div>

                  </div>


                </div>

                <div [id]="'collapse'+ReportType" class="collapse" [attr.aria-labelledby]="'heading'+ReportType" [attr.data-parent]="'#accordion'+ReportType">
                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                    <div class="row margin-left-0px margin-right-0px">

                      <div class="badge badge-graph-background width-auto height-auto margin-right-5px margin-left-5px margin-bottom-5px"
                           [style.background-color]="changeBackground(p)"
                           *ngFor="let p of MisReportXYControllerData">
                        <div class="row">

                          <div class="col-md-12 padding-left-10px text-align-left">
                            <label class="margin-bottom-0px font-size-14px font-weight-bold "
                                   style="color: white!important;">{{p.xName}}</label>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <h4 class="margin-bottom-0px  font-size-18px data-color-white">
                              {{p.yValue}}
                            </h4>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="table-component" hidden>
              <div class="table-responsive">


                <table class="table table-striped margin-left-zero">


                  <tbody class="table-body">
                    <!--<ng-container *ngFor="let l of CurrentSingleWellInseminationByCycleController;let i = index">-->
                    <!--</ng-container>-->
                    <tr *ngFor="let p of MisReportXYControllerData">



                      <td class="padding-top-0px padding-bottom-0px">{{p.xName}}</td>

                      <td class="padding-top-0px padding-bottom-0px"> {{p.yValue | number:'1.0-0'}}</td>





                    </tr>
                  </tbody>

                </table>

              </div>
            </div>
          </div>
        </div>


        <!--<div *ngFor="let p of MisReportXYControllerData">
          <div class="row">
            <div class="col-md-4">
              {{p.xName}}
            </div>
            <div class="col-md-8">
              {{p.yValue}}
            </div>
          </div>

        </div>-->




      </div>
    </div>


  </div>

</div>


